export const CARE_ORDER_BABY_FORM_FIELD_ERROR_TYPE_MAP = {
    contactName: 'contactName',
    contactGender: 'contactGender',
    contactPhone: 'contactPhone',
    contactEmail: 'contactEmail',
    hospitalObj: 'hospitalObj',
    gender: 'gender',
    height: 'height',
    weight: 'weight',
    age: 'age',
    hospitalBed: 'hospitalBed',
    symptom: 'symptom',
    tube: 'tube',
    requiredGender: 'requiredGender',
    lang: 'lang',
    servedItem: 'servedItem',
    notes: 'notes',
    timeSlotList: 'timeSlotList',
};
export const PARAM_VERIFY_ERROR_TYPE_CARE_ORDER_BABY_FORM_ERROR_TYPE_MAP = {
    'contact.name': 'contactName',
    'contact.gender': 'contactGender',
    'contact.phone': 'contactPhone',
    'contact.email': 'contactEmail',
    hospital: 'hospitalObj',
    'patient.gender': 'gender',
    'patient.height': 'height',
    'patient.weight': 'weight',
    'patient.age': 'age',
    hospitalBed: 'hospitalBed',
    symptom: 'symptom',
    tube: 'tube',
    requiredGender: 'requiredGender',
    lang: 'lang',
    servedItem: 'servedItem',
    notes: 'notes',
    timeSlotList: 'timeSlotList',
};
export const FORM_FIELD_ERROR_FEEDBACK_TEXT = {
    DEFAULT: '＊發生錯誤，請重新選擇。',
    EMPTY_NOT_ALLOWED: '＊必填欄位不可空白，請檢查後再送出。',
    INVALID_NUMBER_RANGE: '＊數字範圍錯誤，請修正後再送出。',
    INVALID_LENGTH: '＊超過字數範圍，請修正後再送出。',
    INVALID_FORMAT: '＊資料輸入有誤，請檢查後再送出。',
    INVALID_PHONE_NUMBER: '＊請輸入09開頭的10碼手機號碼',
    UNFINISHED: '＊資料不完整，請檢查後再送出。',
};
